<template>
  <div class="question" :class="{ isGroup: isQuestionGroup }">
    <template v-if="!isQuestionGroup">
      <div class="stem" style="margin-top: 15px">
        <slot></slot>
        <div class="stem-box" style="line-height: 28px; flex: 1; min-width: 0; display: flex">
          <div v-if="activityType == 1">
            <div class="questionStyle" v-if="isRadio">单选题</div>
            <div class="questionStyle" v-if="isCheck">多选题</div>
            <div class="questionStyle" v-if="showJudgeAnswer">判断题</div>
            <div class="questionStyle" style="margin-bottom: 10px;" v-if="showRichTextAnswer">简答题</div>
          </div>
          <div v-if="activityType == 0">
            <div class="questionStyle" v-if="isRadio">单选</div>
            <div class="questionStyle" v-if="isCheck">多选</div>
            <div class="questionStyle" v-if="showJudgeAnswer">判断</div>
            <div class="questionStyle" style="margin-bottom: 10px;" v-if="showRichTextAnswer">简答</div>
          </div>
          <div>
            <div class="questionSeq" v-if="seq && !$slots.seq">{{ seq }}. </div>
          </div>
          <bc-view-common style="display: flex;flex-direction: row;" :content="questionInfo.stem.content"
            :border="false" :fileInfo="questionInfo.stem.fileInfo" @play="changePlay" v-if="!parentIsBigCloze"
            :playbackControl="questionInfo.playbackControl">
          </bc-view-common>
          <div class="questionScore" v-if="questionInfo.questionScore && questionInfo.questionScore >= 0 &&
    !mobile" style="margin-right: 5px;width: 60px;">
            ({{ questionInfo.questionScore }}分)
          </div>
          <div class="questionScore" v-if="questionInfo.questionScore && questionInfo.questionScore >= 0 &&
    mobile" style="margin-right: 5px;width: 60px;">
            ({{ questionInfo.questionScore }}分)
          </div>
          <div class="questionScore" v-if="parentIsBigCloze && questionInfo.questionScore && questionInfo.questionScore >= 0 &&
    mobile" style="margin-right: 5px;width: 60px;">
            ({{ questionInfo.questionScore }}分)
          </div>

        </div>
      </div>

      <div v-if="isRadio" class="mt-4">
        <bc-view-option-radio :answer="answerRecord" :typeOk="typeOk" :isAnswerx="questionInfo.isAnswer"
          :isAnswerResults="questionInfo.isAnswerResults" :readonly="!!answerRecordList.length || isRecord"
          @change="changeAnswer" :option="questionInfo.questionOption" :styleType="styleType"></bc-view-option-radio>
      </div>

      <div v-if="isCheck" class="mt-4">
        <bc-view-option-checkbox :answer="answerRecord" :typeOk="typeOk" :isAnswerx="questionInfo.isAnswer"
          :isAnswerResults="questionInfo.isAnswerResults" :readonly="!!answerRecordList.length || isRecord"
          @change="changeAnswer" :option="questionInfo.questionOption" :styleType="styleType"></bc-view-option-checkbox>
      </div>

      <div v-if="showJudgeAnswer" class="mt-4">
        <bc-view-option-radio type="judge" :answer="answerRecord" :typeOk="typeOk" :styleType="styleType"
          :isAnswerResults="questionInfo.isAnswerResults" :isAnswerx="questionInfo.isAnswer"
          :readonly="!!answerRecordList.length || isRecord" @change="changeAnswer($event === 'A' ? '正确' : '错误')"
          :option="[
    { title: 'A', content: '正确' },
    { title: 'B', content: '错误' },
  ]"></bc-view-option-radio>
      </div>

      <div v-if="isLineQuestion" class="mt-4">
        <bc-line-question-answer style="flex: 1; min-width: 0" :options="questionInfo.questionOption || []"
          :key="questionInfo.id" @change="changeAnswer" :mobile="mobile" :answer="answerRecord" :typeOk="typeOk"
          :readonly="!!answerRecordList.length || isRecord" :isAnswerx="questionInfo.isAnswer"
          :isAnswerResults="questionInfo.isAnswerResults"
          :isAnswertype="questionInfo.isAnswertype"></bc-line-question-answer>
      </div>

      <div v-if="showSort" class="mt-4">
        <bc-answer-sort :answer="answerRecord" :typeOk="typeOk" :readonly="!!answerRecordList.length || isRecord"
          :options="questionInfo.questionOption" @change="changeAnswer" :isAnswerx="questionInfo.isAnswer"
          :isAnswerResults="questionInfo.isAnswerResults"></bc-answer-sort>
      </div>

      <div v-if="isCloze" class="mt-4">
        <bc-answer-cloze :clozeMaxLength="clozeMaxLength" :answer="answerRecord" :typeOk="typeOk"
          :readonly="!!answerRecordList.length || isRecord" :length="clozeLength" @change="changeAnswer"
          :isAnswerx="questionInfo.isAnswer" :isAnswerResults="questionInfo.isAnswerResults"></bc-answer-cloze>
      </div>

      <div v-if="showRichTextAnswer" class="mt-4">
        <textarea :maxlength="shortAnswerMaxLength" v-if="!answerRecordList.length && !isRecord" class="textarea"
          v-model="richText" placeholder="请输入..." @input="changeAnswer(richText)" :disabled="richOptions"></textarea>
        <textarea v-else class="textarea" :class="answerRecord.answerResults ? 'isTrue' : 'isFalse'" readonly
          v-model="answerRecord.answerResults"></textarea>
      </div>
      <div class="StatisticsTitle" v-if="isView.isViewStatistics == '0'">
        本题已有{{ sum(questionInfo.answerQuestionStatisticsVos) }}人回答</div>
      <div v-if="isView.isViewAnswer == '0' && questionInfo.answerQuestionRecordVo.gradeDescribe"
        class="StatisticsTitle">
        批阅：{{ questionInfo.answerQuestionRecordVo.gradeDescribe }}</div>
      <template v-if="questionInfo.selectAnswer || isRecord">
        <div v-if="isView.isViewAnswer == '0'">
          <template v-if="showSort">
            <div class="mt-6" style="margin-top: 10px">
              <div flex>
                <div class="question-label">正确答案：</div>
                <div style="color: #0070c1; min-width: 0; flex: 1">
                  {{ standardAnswer }}
                </div>
              </div>
            </div>

          </template>


          <div class="mt-6" v-else-if="showRichTextAnswer" style="margin-top: 10px">
            <div flex="1">
              <div class="question-label">正确答案：</div>
              <div style="flex: 1; min-width: 0">
                <bc-view-common :content="questionInfo.standardAnswer.content" :border="false"
                  style="flex: 1; min-width: 0" :fileInfo="questionInfo.standardAnswer.fileInfo"></bc-view-common>
              </div>
            </div>
          </div>

          <div v-else-if="isHideAnswer"></div>
          <template v-else-if="isLineQuestion">
            <div style="margin-top: 10px">
              <div style="margin: 10px 0" class="question-label">正确答案：</div>
              <div>
                <bc-line-question-view-line style="flex: 1; min-width: 0" :mobile="mobile"
                  :options="questionInfo.questionOption || []"></bc-line-question-view-line>
              </div>
            </div>
          </template>

          <template v-else-if="isCloze">
            <div class="mt-6" style="margin-top: 10px">
              <div flex="1">
                <div class="question-label">正确答案：</div>
                <div v-for="(item, index) in questionInfo.standardAnswer" :key="index">
                  <div class="isCloze_box" v-html="item.content"></div>
                </div>
              </div>
            </div>

            <div class="mt-6" style="margin-top: 10px" v-if="questionInfo.answerSequence">
              <div flex>
                <div class="question-label">作答顺序：</div>
                <div>{{ questionInfo.answerSequence }}</div>
              </div>
            </div>
          </template>

          <div class="mt-6" style="margin-top: 10px" v-else>
            <div class="isRadio_box">
              <div class="question-label">正确答案：</div>
              <div style="color: #0070c1; min-width: 0; flex: 1; line-height: 28px">
                <span v-if="questionInfo.questionType == 3">
                  {{ standardAnswer }}
                </span>
                <template v-else>
                  <span v-for="(item, index) in getPaperList(questionInfo.questionOption)" :key="index"
                    v-show="standardAnswer.includes(item.title)">
                    {{ serialNumber[index] }}
                  </span>
                </template>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-4" flex="cross:center" style="line-height: 28px" v-if="showStatistics && !mobile">
          <div v-if="styleType == 1">
            <div style="margin-right: 50px">
              难度：{{ dict.label.difficulty[questionInfo.difficulty] }}
            </div>
            <div flex="cross:center">
              <div style="color: #0070c1">
                共答过{{
    questionInfo.astatistics
      ? questionInfo.astatistics.totalAnswersNum
      : 0
  }}次， 答对{{
      questionInfo.astatistics
        ? questionInfo.astatistics.correctAnswersNum
        : 0
    }}次，答错{{
      questionInfo.astatistics
        ? questionInfo.astatistics.wrongAnswersNum
        : 0
    }}次
              </div>
            </div>
          </div>
        </div>
        <div v-if="isView.isViewAnswer == '0'">
          <div class="question-label" style="line-height: 40px">答案解析：</div>
          <div flex v-if="showAnalysis">
            <div style="min-width: 0; flex: 1" class="stem"
              :class="{ 'analysis-content': questionInfo.analysis.content }">
              <bc-view-common v-if="questionInfo.analysis.content ||
    (questionInfo.analysis.fileInfo &&
      questionInfo.analysis.fileInfo.fileUrl)
    " :border="false" :content="questionInfo.analysis.content"
                :fileInfo="questionInfo.analysis.fileInfo"></bc-view-common>

              <div class="analysis-content" v-else>暂无解析</div>
              <div style="height: 5px"></div>
            </div>
          </div>
          <div style="min-width: 0; flex: 1; cursor: pointer" class="stem analysis-content" v-if="aishow == 'true'">
            <img @click="openAi(questionInfo)" src="@/assets/images/ai.png" />
          </div>
        </div>

      </template>

    </template>
    <template v-else>
      <slot></slot>
      <div flex style="flex: 1; min-width: 0" class="questionGroupContent">
        <div flex>
          <div class="questionSeq" v-if="seq" style="margin-right: 16px; margin-top: 20px">
            {{ seq }}.
          </div>
          <div class="questionType">
            【{{ dict.label.question_type[questionInfo.questionType] }}】
          </div>
          <div class="questionScore" v-if="questionInfo.questionScore &&
    questionInfo.questionScore >= 0 &&
    !mobile
    " style="margin-right: 10px">
            ({{ questionInfo.questionScore }}分)
          </div>
        </div>

        <div class="group-content">
          <bc-view-common style="flex: 1; min-width: 0" :content="questionInfo.stem.content" :border="false"
            :fileInfo="questionInfo.stem.fileInfo" :playbackControl="questionInfo.playbackControl">
            <div class="questionScore" v-if="questionInfo.questionScore &&
    questionInfo.questionScore >= 0 &&
    mobile
    " style="margin-right: 10px">
              ({{ questionInfo.questionScore }}分)
            </div>
          </bc-view-common>
          <div v-if="questionInfo.questionList">
            <div v-for="(item, index) in questionInfo.questionList" :key="index">
              <bc-answer-question @change="changeQuestionGroup($event, index)" :dict="dict" :seq="index + 1"
                :key="item.id" :typeOk="typeOk" :question="item" :answer-record-list="answerRecordList"
                :is-record="isRecord" :show-statistics="showStatistics" :mobile="mobile" :parentIsBigCloze="isBigCloze"
                :playbackControl="item.playbackControl" :show-type="!isBigCloze"
                :style="{ paddingLeft: isBigCloze ? '0' : '20px' }">
                <div slot="seq">
                  {{ isBigCloze ? "选项" : "小题" }}{{ index + 1 }}.S
                </div>
              </bc-answer-question>
              <div class="isGroups_but" v-if="typeOk == 'false'">
                <el-button v-if="!item.isAnswer" type="primary" round @click="isGroups(index)">选好了</el-button>
                <el-button v-if="item.isAnswer" type="info" round>选好了</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { robotBook } from "@/utils/config.js";
import {
  isBigCloze,
  isCheck,
  isCloze,
  isHideAnswer,
  isLineQuestion,
  isQuestionGroup,
  isRadio,
  showAnalysis,
  showJudgeAnswer,
  showOptions,
  showRichTextAnswer,
  showSort,
} from "@/utils/questionType";
import XEUtils from "xe-utils";
import { debounce } from "lodash";
export default {
  name: "bc-answer-question",
  props: {
    typeOk: {
      type: String,
      default: "false",
    },
    isView: {
      type: [String, Object],
      default: {
        isViewAnswer: "1",
        isViewStatistics: "1"
      }
    },
    question: {
      type: Object,
      default: () => { },
    },
    testPaperDetailName: {
      type: String,
      default: "",
    },
    aishow: {
      type: String,
      default: "false",
    },
    seq: {
      type: Number,
      default: 0,
    },
    showType: {
      type: Boolean,
      default: true,
    },
    dict: {
      type: Object,
      default: () => { },
    },
    answerRecordList: {
      type: Array,
      default: () => [],
    },
    isRecord: {
      type: Boolean,
      default: false,
    },
    showStatistics: {
      type: Boolean,
      default: true,
    },
    mobile: {
      type: Boolean,
      default: false,
    },
    parentIsBigCloze: {
      default: false,
      type: Boolean,
    },
    err: {
      default: true,
      type: Boolean,
    },
    styleType: {
      type: [String, Number],
      default: "1",
    },
    activityType: {
      type: String,
      default: "1",
    }
  },
  watch: {
    question: {
      handler(val) {
        try {
          this.questionInfo = {
            ...val,
            stem: val.stem ? JSON.parse(val.stem) : {},
            analysis: val.analysis ? JSON.parse(val.analysis) : {},
            standardAnswer: val.standardAnswer
              ? JSON.parse(val.standardAnswer)
              : {},
            questionOption: val.questionOption
              ? JSON.parse(val.questionOption)
              : "[]",
          };
          console.log(this.questionInfo);
          if (this.questionInfo.isAnswerResults) {
            let val = this.questionInfo.isAnswerResults;
            if (val.questionId || val.value) {
              //题组
              this.richText = this.questionInfo.isAnswerResults.value;
            } else {
              this.richText = this.questionInfo.isAnswerResults;
            }
          }
        } catch (err) {
          console.log(err);
        }
      },
      immediate: true,
      deep: true,
    },
  },

  computed: {
    richOptions() {
      let isAnswer = false;
      if (this.typeOk == "true") {
        isAnswer = false;
      } else {
        isAnswer = this.questionInfo.isAnswer;
      }
      return isAnswer;
    },
    showOptions() {
      return showOptions(this.questionInfo.questionType);
    },
    showJudgeAnswer() {
      return showJudgeAnswer(this.questionInfo.questionType);
    },
    showSort() {
      return showSort(this.questionInfo.questionType);
    },
    showRichTextAnswer() {
      return showRichTextAnswer(this.questionInfo.questionType);
    },
    showAnalysis() {
      return showAnalysis(this.questionInfo.questionType);
    },
    isHideAnswer() {
      return isHideAnswer(this.questionInfo.questionType);
    },
    isLineQuestion() {
      return isLineQuestion(this.questionInfo.questionType);
    },
    isCloze() {
      return isCloze(this.questionInfo.questionType);
    },
    isBigCloze() {
      return isBigCloze(this.questionInfo.questionType);
    },
    isRadio() {
      return isRadio(this.questionInfo.questionType);
    },
    isCheck() {
      return isCheck(this.questionInfo.questionType);
    },
    isQuestionGroup() {
      return isQuestionGroup(this.questionInfo.questionType);
    },
    standardAnswer() {
      try {
        let answerTitle = "";
        if (!this.showRichTextAnswer) {
          if (this.showOptions) {
            answerTitle = this.questionInfo.standardAnswer
              .map((i) => i.title)
              .join("、");
          } else if (this.showJudgeAnswer) {
            answerTitle = this.questionInfo.standardAnswer
              .map((i) => i)
              .join("、");
          } else if (this.showSort) {
            let questionOption = XEUtils.clone(
              this.questionInfo.questionOption,
              true
            );
            answerTitle = questionOption
              .sort((c, n) => c.index - n.index)
              .map((i) => i.title)
              .join("、");
          }
        }
        return answerTitle;
      } catch (e) {
        return "";
      }
    },
    clozeLength() {
      let fillInTheBlanksSpan =
        this.questionInfo.stem.content.match(/fillInTheBlanksSpan/g);
      return fillInTheBlanksSpan ? fillInTheBlanksSpan.length : 0;
    },
    answerRecord() {
      let answer = this.answerRecordList.find(
        (i) => i.questionId === this.questionInfo.id
      );
      let data = { answerResults: "", answerSituation: "0" };
      if (answer) {
        data.answerResults = answer.answerResults;
        data.answerSituation = answer.answerSituation;
      }
      return data;
    },
  },

  data() {
    return {
      bookdetail: "建筑构造",
      goodsId: "1714141161700069376",
      robotBook: "",
      isGrouptype: "确定",
      questionInfo: {},
      richText: "",
      aiBox: false,
      originAnswer: "",
      clozeMaxLength: 100,
      shortAnswerMaxLength: 100,
      questionGroupList: {},
      list: [
        {
          loading: true,
          content: "",
          type: "text",
        },
      ],
      serialNumber: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
    };
  },
  created() {
    this.robotBook = robotBook;
    this.changeAnswer = debounce(this.changeAnswerDebouce, 200);
  },
  methods: {
    sum(arr) {
      if (!arr) {
        return 0
      }
      return arr.reduce((prev, cur) => {
        return prev + cur.number
      }, 0)
    },
    openAi(e) {
      console.log(e);
      var data = e.stem.content;
      let serialNumber = [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
      ];
      let option = "";
      let question = e.stem.content;
      let optionList = e.questionOption;

      for (let i = 0; i < optionList.length; i++) {
        if (optionList[i].content) {
          option +=
            serialNumber[i] +
            "." +
            this.removeStyle(optionList[i].content) +
            (i < optionList.length - 1 ? ";" : "");
        }
      }
      if (e.questionType == "3") {
        option = "A.正确;B.错误";
      }

      this.$emit("openAi", this.removeStyle(question) + option);
      // this.$refs.robotBox.robotShwo = true;
      // this.$refs.robotBox.sending(data.replace(/&nbsp;/gi, ""));
    },
    getPaperList(list) {
      if (list.length > 0) {
        let answerList = [];
        list.map((item) => {
          if (typeof item == "string") {
            let data = {
              selected: false,
              ...JSON.parse(item),
            };
            answerList.push(data);
          } else {
            this.$set(item, "selected", false);
            answerList = list;
          }
        });
        return answerList;
      }
    },

    removeStyle(e) {
      e = e.replace(/<[^>]+>/g, ""); //去除所有标签，以纯文本展示
      e = e.replace(/\s/gi, ""); //去除空格
      return e;
    },

    aiQuestion() {
      let serialNumber = [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
      ];
      let option = "";
      let question = this.questionInfo.stem.content;
      let optionList = this.questionInfo.questionOption;

      for (let i = 0; i < optionList.length; i++) {
        if (optionList[i].content) {
          option +=
            serialNumber[i] +
            "." +
            this.removeStyle(optionList[i].content) +
            (i < optionList.length - 1 ? ";" : "");
        }
      }
      if (this.questionInfo.questionType == "3") {
        option = "A.正确;B.错误";
      }

      const data = {
        type: "AiAnalysis",
        value: this.removeStyle(question) + option,
        code: "success",
      };
      console.log("🚀 ~ file: index.vue:660 ~ aiQuestion ~ data:", data);
      // 向父vue页面发送信息
      window.parent.postMessage(
        {
          data,
        },
        "*"
      );
    },
    // 获取小智答疑答案
    async loadData(question, index) {
      this.list[index].loading = true;
      let controller = new AbortController();
      let postData = {
        query: question,
        book: "建筑构造",
        stream: "True",
      };
      try {
        const response = await fetch(process.env.VUE_APP_roboturl, {
          method: "post",
          headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
          body: JSON.stringify(postData),
          signal: controller.signal,
        });
        const reader = response.body.getReader();
        let data = "";
        let videoUrl = "";
        let content = "";
        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            // setLoading(false);
            break;
          }
          data += new TextDecoder().decode(value);
          if (data.indexOf("DONE") !== -1) {
            this.list[index].loadingCompleted = true;
          }
          content = "";
          let eaderStream = data.split("\r\n\r\n");
          eaderStream.map((item) => {
            if (item) {
              let textData = item.split("data:");

              textData.map((items) => {
                if (items && items.indexOf("{") !== -1) {
                  let text = JSON.parse(items);
                  if (text.content) {
                    content += text.content;
                  }
                } else if (items.indexOf(".mp4") !== -1) {
                  videoUrl = items.slice(1, items.length - 7);
                }
              });
            }
          });
          this.list[index].loading = false;
          this.list[index].content = content;
          this.list[index].type = "text";
          this.list[index].videoUrl = videoUrl;
        }
      } catch {
        this.list[index].loading = false;
        this.list[index].loadingCompleted = true;
        this.list[index].content =
          "亲，我的知识库里无法找到答案，请您修改问题重新提问。";
        this.list[index].type = "text";
      }
    },
    changeAnswerDebouce(val) {
      if (val !== this.originAnswer) {
        this.originAnswer = val;
        this.$emit("change", { value: val, questionId: this.questionInfo.id });
      }
    },
    changePlay() {
      if (isHideAnswer(this.questionInfo.questionType)) {
        if (this.originAnswer !== "1") {
          this.originAnswer = "1";
          this.$emit("change", { value: 1, questionId: this.questionInfo.id });
        }
      }
    },
    changeQuestionGroup(val, index) {
      console.log(val);
      this.$emit("change", {
        value: val,
        questionId: this.questionInfo.id,
        questionIndex: index,
      });
      let data = {
        value: val,
        questionId: this.questionInfo.id,
        questionIndex: index,
      };
      this.questionGroupList = data;
    },
    isGroups(index) {
      this.questionGroupList.questionIndex = index;
      this.$emit("changeCancel", this.questionGroupList);
    },
  },
};
</script>

<style scoped lang="scss">
.textarea {
  width: 100%;
  height: 100px;
  background: #fbfbfb;
  border-radius: 6px;
  border: 1px solid #fbfbfb;
  outline: none;
  padding: 6px;
  resize: none;

  &.isTrue {
    border-color: #70b603;
  }

  &.isFalse {
    border-color: #d9001b;
  }
}

.group-content {
  flex: 1;
  min-width: 0;
}

.aiButtom {
  margin-top: 8px;
  cursor: pointer;
}

.isRadio_box {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.isGroups_but {
  width: 500px;
  margin: 20px 400px;
}

.isCloze_box {
  background: #fbfbfb;
  padding: 10px;
  margin: 10px;
  width: 855px;
}

.box_Ai {
  background: #2e9adb;
  padding: 5px;
  color: #fff;
  width: 50px;
  border-radius: 5px;
}

.questionStyle {
  padding: 0 5px;
  width: 60px;
  font-size: 12px;
  margin: 0 5px;
  height: 26px;
  border-radius: 5px;
  text-align: center;
  color: #fff;
  background-color: #F59A23;
}

.StatisticsTitle {
  color: #F7B229;
  font-size: 15px;
  margin: 10px 0;
}
</style>
